import {useDispatch} from 'react-redux'
import { logOut } from '../actions';


export const AutoRefreshConnexion = ()=>{
    const dispatch = useDispatch();
    dispatch(logOut())
}
